<div class="row" *ngIf="form as form" [formGroup]="form">
  <div class='col-md-4'>
    <div class='form-group' *ngIf='"firstName" as controlName'>
      <label [for]='controlName'>
        Imię/Imiona *
      </label>
      <input
        [id]='controlName'
        [ngClass]='{ "is-invalid": form.showError(controlName) }'
        [formControlName]='controlName'
        placeholder='Wpisz tu imię/imiona'
        type='text'>
      <app-validation-errors [control]='form.get(controlName)'>
      </app-validation-errors>
    </div>
  </div>
  <div class='col-md-4'>
    <div class='form-group' *ngIf='"lastName" as controlName'>
      <label [for]='controlName'>
        Nazwisko *
      </label>
      <input
        [id]='controlName'
        [formControlName]='controlName'
        [ngClass]='{ "is-invalid": form.showError(controlName) }'
        placeholder='Wpisz tu nazwisko'
        type='text'>
      <app-validation-errors [control]='form.get(controlName)'>
      </app-validation-errors>
    </div>
  </div>
  <div class='col-md-4'>
    <div class='form-group' *ngIf='"birthDate" as controlName'>
      <label [for]='controlName'>
        Data urodzenia *
      </label>
      <app-date-picker [id]='controlName' [formControlName]='controlName'>
      </app-date-picker>
      <app-validation-errors [control]='form.get(controlName)'>
      </app-validation-errors>
    </div>
  </div>
  <div class='col-md-4'>
    <div class='form-group' *ngIf='"fatherName" as controlName'>
      <label [for]='controlName'>
        Imię/Imiona ojca *
      </label>
      <input
        [id]='controlName'
        [ngClass]='{ "is-invalid": form.showError(controlName) }'
        [formControlName]='controlName'
        placeholder='Wpisz tu imię/imiona ojca'
        type='text'>
      <app-validation-errors [control]='form.get(controlName)'>
      </app-validation-errors>
    </div>
  </div>
  <div class='col-md-4'>
    <div class='form-group' *ngIf='"motherName" as controlName'>
      <label [for]='controlName'>
        Imię/Imiona matki *
      </label>
      <input
        [id]='controlName'
        [ngClass]='{ "is-invalid": form.showError(controlName) }'
        [formControlName]='controlName'
        placeholder='Wpisz tu imię/imiona matki'
        type='text'>
      <app-validation-errors [control]='form.get(controlName)'>
      </app-validation-errors>
    </div>
  </div>
  <div class='col-md-4'>
    <div class='form-group' *ngIf='"regon" as controlName'>
      <label [for]='controlName'>
        REGON
      </label>
      <input
        [id]='controlName'
        [formControlName]='controlName'
        [ngClass]='{ "is-invalid": form.showError(controlName) }'
        placeholder='Wpisz tu REGON'
        type='text'>
      <app-validation-errors [control]='form.get(controlName)'>
      </app-validation-errors>
    </div>
  </div>
</div>
